<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import CloseButton from "./CloseButton.svelte";

  export let isOpen: boolean = false;
  export let onClose: () => void = () => {};
  export let closeButtonAriaLabel: string = "Close modal";
  export let modalAriaLabel: string = "modal-title";
  export let modalAriaDescription: string = "modal-message";

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  onMount(() => {
    document.addEventListener("keydown", handleKeyDown);
  });

  onDestroy(() => {
    document.removeEventListener("keydown", handleKeyDown);
  });

  // Overflow management when modal opens/closes
  $: document.body.style.overflow = isOpen ? "hidden" : "";
</script>

{#if isOpen}
  <!-- Backdrop overlay -->
  <button
    type="button"
    class="fixed left-0 top-0 z-50 w-full h-dvh bg-black/50 focus:outline-none"
    on:click={onClose}
    aria-label={closeButtonAriaLabel}
  >
  </button>
  
  <!-- Modal content -->
  <div 
    class="fixed left-0 top-0 z-[51] w-full h-dvh flex justify-center items-center pointer-events-none"
    role="dialog"
    aria-modal="true"
    aria-labelledby={modalAriaLabel}
    aria-describedby={modalAriaDescription}
  >
    <div class="bg-dark border-solid border-white border-4 rounded-[6px] p-4 mobile:p-8 lg:p-12 relative max-w-md pointer-events-auto">
      <!-- Close button -->
      <CloseButton onClick={onClose} classNames="text-white border-white bg-transparent" />
      
      <slot />
    </div>
  </div>
{/if}
